export enum ANNOTATION_DICTATION_SOURCE {
    browserSpeechSynthesis = 'browser-speech-synthesis',
}
